module.exports = __webpack_public_path__ + "img/20ne.d1974ad0.svg";